import type {ProblemOccurrenceId} from '../../../../../types'
import {EXPAND_ARROW_WIDTH, TREE_INDENT_WIDTH} from '../../../../common/Tree/Tree.constants'
import {getKeyForBuildLogData} from '../../../BuildLog/BuildLog.utils'
import BuildLogPreview from '../../../BuildLog/BuildLogPreview/BuildLogPreview.container'
import {getProblemOccurrencesById} from '../../BuildProblems.selectors'

import styles from './BuildProblemsTreeLeafDetails.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  level?: number
  problemOccurrenceId: ProblemOccurrenceId
}

function BuildProblemsTreeLeafDetails({level, problemOccurrenceId}: Props) {
  const {logAnchor, build} =
    useAppSelector(state => getProblemOccurrencesById(state, problemOccurrenceId)) ?? {}
  const buildId = build?.id

  const paddingLeft =
    level != null ? `${level * TREE_INDENT_WIDTH + EXPAND_ARROW_WIDTH}px` : undefined

  return buildId != null && logAnchor != null ? (
    <div style={{paddingLeft}}>
      <div className={styles.details}>
        <BuildLogPreview
          className={styles.buildLog}
          buildId={buildId}
          problemOccurrenceId={problemOccurrenceId}
          focusLine={logAnchor}
          expandLine={logAnchor}
          buildLogKey={getKeyForBuildLogData({type: 'problem', id: problemOccurrenceId})}
          withLoadingData
        />
      </div>
    </div>
  ) : null
}

export default BuildProblemsTreeLeafDetails
